export default {
  navigationBarTitleText: '文件下载'
};
